// Cybras theme behaviour.
//
// Deliberately small. Three things that were JavaScript on the static comp are
// now server-rendered Liquid instead, and must NOT come back here:
//   - hero marquee slides  -> section blocks, duplicated in Liquid
//   - product cards        -> a real collection loop
//   - FAQ questions        -> section blocks
// Rendering those on the client would hide them from crawlers and from the
// theme editor, and the client could no longer edit them.

// ---- Scroll reveals -------------------------------------------------------
// IntersectionObserver, not a scroll handler: sections are added and removed
// live by the theme editor, so re-observing on demand is cheaper and does not
// leave orphaned elements stuck at opacity 0.
let io;
function observeReveals() {
  if (!io) {
    io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  }
  document.querySelectorAll('[data-reveal]:not(.is-in)').forEach((el) => io.observe(el));
}

// ---- Header shadow on scroll ---------------------------------------------
function initHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  addEventListener('scroll', () => {
    header.classList.toggle('shadow-[0_10px_30px_-24px_rgba(0,39,43,.5)]', scrollY > 8);
  }, { passive: true });
}

// ---- Mobile nav -----------------------------------------------------------
function initMobileNav() {
  const navToggle = document.getElementById('nav-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  if (!navToggle || !mobileNav) return;
  navToggle.addEventListener('click', () => {
    const open = mobileNav.classList.toggle('hidden') === false;
    navToggle.setAttribute('aria-expanded', String(open));
  });
}

// ---- Carousels ------------------------------------------------------------
// Generic: any [data-carousel] with a [data-carousel-track] scroll-snap track,
// optional [data-carousel-prev]/[data-carousel-next] buttons (shipped disabled
// in markup; armed here) and an optional [data-carousel-dots] container that
// gets one dot per page. Dot classes are literal strings on purpose - Tailwind
// scans assets/**/*.js, a class built from variables would be purged.
function initCarousels() {
  document.querySelectorAll('[data-carousel]:not([data-carousel-ready])').forEach((root) => {
    const track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    root.setAttribute('data-carousel-ready', '');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    const dotsBox = root.querySelector('[data-carousel-dots]');
    const DOT = 'h-1.5 w-1.5 rounded-full bg-teal/60 transition-all';
    const DOT_ACTIVE = 'h-1.5 w-6 rounded-full bg-tealink transition-all';

    const pageCount = () => Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
    const page = () => Math.min(pageCount() - 1, Math.round(track.scrollLeft / track.clientWidth));

    function sync() {
      const n = pageCount();
      const p = page();
      if (prev) prev.disabled = p <= 0;
      if (next) next.disabled = p >= n - 1;
      if (dotsBox) {
        if (dotsBox.children.length !== n) {
          dotsBox.innerHTML = '';
          for (let i = 0; i < n; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Go to page ' + (i + 1));
            b.addEventListener('click', () => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }));
            dotsBox.appendChild(b);
          }
        }
        [...dotsBox.children].forEach((d, i) => { d.className = i === p ? DOT_ACTIVE : DOT; });
      }
    }

    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));

    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });
    let rt;
    addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(sync, 150); });
    sync();
  });
}

function init() {
  initHeader();
  initMobileNav();
  observeReveals();
  initCarousels();
  requestAnimationFrame(() => document.documentElement.classList.add('hero-ready'));
}

document.addEventListener('DOMContentLoaded', init);

// The theme editor swaps section markup in without a page load, so anything
// added after boot needs re-observing or it stays invisible at opacity 0.
// Carousels likewise: a re-added section arrives with unbound, disabled arrows.
document.addEventListener('shopify:section:load', () => { observeReveals(); initCarousels(); });
document.addEventListener('shopify:section:select', observeReveals);
